import { app } from '../../../../bootstrap/core';
import { partnerListComponent } from './partnerList.component';
import '../partnerItem/partnerItem';
import '../partnerDetailItem/partnerDetailItem';

app.component('partnerList', partnerListComponent);
